import { BundleAssignmentStore } from "../../interfaces";
import { BundleAssignmentTypes } from "../types";

const initialState: BundleAssignmentStore = {
    inventario: [],
    lotes: [],
    armadores: [],
    revisiones: {},
    devoluciones: {},
    loading: false,
    success: false,
    selectedLoteId: null,
};

const applyDashboardPayload = (
    state: BundleAssignmentStore,
    payload: Partial<BundleAssignmentStore>
): BundleAssignmentStore => ({
    ...state,
    inventario: payload.inventario ?? state.inventario,
    lotes: payload.lotes ?? state.lotes,
    armadores: payload.armadores ?? state.armadores,
    revisiones: payload.revisiones ?? state.revisiones,
    devoluciones: payload.devoluciones ?? state.devoluciones,
    loading: payload.loading ?? false,
    success: payload.success ?? state.success,
});

export const bundleAssignment = (
    state = initialState,
    action: { type: string; payload?: Partial<BundleAssignmentStore> }
): BundleAssignmentStore => {
    switch (action.type) {
        case BundleAssignmentTypes.GET_DASHBOARD_LOADING:
        case BundleAssignmentTypes.CREATE_LOTE_LOADING:
        case BundleAssignmentTypes.SUBMIT_REVISION_LOADING:
        case BundleAssignmentTypes.APPROVE_LOTE_LOADING:
            return { ...state, loading: true };

        case BundleAssignmentTypes.GET_DASHBOARD_SUCCESS:
        case BundleAssignmentTypes.CREATE_LOTE_SUCCESS:
        case BundleAssignmentTypes.SUBMIT_REVISION_SUCCESS:
        case BundleAssignmentTypes.APPROVE_LOTE_SUCCESS:
            return applyDashboardPayload(state, {
                ...action.payload,
                loading: false,
                success: true,
            });

        case BundleAssignmentTypes.GET_DASHBOARD_FAILURE:
        case BundleAssignmentTypes.CREATE_LOTE_FAILURE:
        case BundleAssignmentTypes.SUBMIT_REVISION_FAILURE:
        case BundleAssignmentTypes.APPROVE_LOTE_FAILURE:
            return { ...state, loading: false, success: false };

        case BundleAssignmentTypes.SET_SELECTED_LOTE:
            return {
                ...state,
                selectedLoteId: action.payload?.selectedLoteId ?? null,
            };

        default:
            return state;
    }
};
